/**
 * Shared visual constants for the Summit workspace.
 *
 * NOTE: this file intentionally does NOT export a font-family stack.
 * The host app applies its own font automatically; every component in
 * this feature relies on that default (via `font-size`/`font-weight`
 * only) instead of hardcoding a stack. If you're tempted to add a
 * `font-family` anywhere in this feature, don't — that's a deliberate,
 * confirmed product decision, not an oversight.
 */

/**
 * Selected-row treatment, matched to the active-item styling used
 * elsewhere in the app (e.g. the highlighted "Locale Strings" nav
 * entry: light red tint + red accent + red text). The previous
 * selected state here only added a thin border and a barely-different
 * gray background, which is easy to miss at a glance — this makes the
 * selected user/machine unambiguous.
 *
 * These two hex values were sampled directly, pixel-by-pixel, from the
 * reference screenshot's highlighted "Locale Strings" row — both the
 * border and the text itself use the exact same red. Hardcoding them
 * here (rather than reaching for `colors.main.negative`) guarantees a
 * pixel-accurate match instead of hoping that token happens to resolve
 * to the same shade. If `melco-ui`'s DesignTokens ever expose a named
 * token for this exact red, prefer that over the hardcoded value below.
 */
export const SELECTED_BG = "#FFEAE6";
export const SELECTED_ACCENT = "#EB0000";
